/** @flow */

import type { State } from "@store/reducers";
import type {
  AbsenceReasonReport,
  AbsenceReasonReportDetails,
  AbsenceProfile,
  AbsenceReasonReportViewState,
} from "@modules/reporting/reducer/trends/absence-reason/types";

import { enrichReportData } from "./report-enricher";
import type { AbsenceReasonState } from "@modules/reporting/reducer/trends/absence-reason/types";

export const getAbsenceReason = (state: State): AbsenceReasonState => {
  return state.reporting.trends.absenceReason;
};

export const getDefaultReports = (state: State): Array<AbsenceReasonReport> =>
  getAbsenceReason(state).defaultReports || [];

export const getMyReports = (state: State): Array<AbsenceReasonReport> =>
  getAbsenceReason(state).myReports || [];

export const getReportData = (state: State): AbsenceReasonReportDetails =>
  getAbsenceReason(state).report;

export const getEnrichedReportData = (state: State): AbsenceReasonReportDetails => {
  return enrichReportData(getReportData(state));
};

export const getViewState = (state: State): AbsenceReasonReportViewState =>
  state.reporting.trends.absenceReason.viewState;

export const getAbsenceProfile = (state: State): AbsenceProfile | null =>
  getAbsenceReason(state).absenceProfile;

export const getReportsSchema = (state: State): ?Object => getAbsenceReason(state).schema;

export const getReportToSave = (state: State): ?AbsenceReasonReport =>
  getAbsenceReason(state).reportToSave;

export const isLoading = (state: State): boolean =>
  !!state.reporting.trends.absenceReason.requestsInProgress;

export const isReportGenerateInProgress = (state: State): boolean =>
  !!state.reporting.trends.absenceReason.reportGenerateInProgress;
